// extracted by mini-css-extract-plugin
export default {"statistic":"ContentfulStatistics-module__statistic__G4Ki7z0"};